import { Add, Edit, AddCircleOutline, Receipt, RemoveRedEye } from '@mui/icons-material'
import store from 'state/store'
import { showFormModal } from 'state/ui'
import { MODAL_VIEW_MODES } from 'utils/constants'
import FORM_MODALS from './modals'

export interface AppAction {
  icon?: JSX.Element
  text: string
  id: string
  actionPath: string // Used for RBAC permission checking
  onClick: ((navigate: (path: string) => void) => void) | (() => void)
  variant?: 'outlined' | 'contained' | 'text'
}

export const INVENTORY_ACTIONS: AppAction[] = [
  {
    actionPath: 'inventory/regrades',
    icon: <Edit />,
    text: 'Regrade Material',
    id: 'regrade-material-button',
    onClick: () => {
      store.dispatch(
        showFormModal({
          formModalName: FORM_MODALS.NEW_REGRADE,
          formModalProps: {
            viewMode: MODAL_VIEW_MODES.NEW,
            navigateTo: '/app/inventory/regrades',
          },
        }),
      )
    },
  },
  {
    actionPath: 'inventory/finished-goods',
    icon: <Add />,
    text: 'Finished Goods',
    id: 'finished-goods-button',
    onClick: () => {
      store.dispatch(
        showFormModal({
          formModalName: FORM_MODALS.NEW_FINISHED_GOOD,
          formModalProps: {
            viewMode: MODAL_VIEW_MODES.NEW,
            isUpdate: false,
            navigateTo: '/app/inventory/finished-goods',
          },
        }),
      )
    },
  },
  {
    actionPath: 'inventory/packing-lists/new',
    icon: <Add />,
    text: 'Packing List',
    id: 'packing-list-button',
    onClick: navigate => {
      navigate('/app/inventory/packing-lists/new')
    },
  },
  {
    actionPath: 'inventory/adjustments/new',
    icon: <Add />,
    text: 'Adjustment',
    id: 'adjustment-button',
    onClick: navigate => {
      navigate('/app/inventory/adjustments/new')
    },
  },
]

export const MATERIALS_ACTIONS = [
  // {
  //   icon: <CloudUpload />,
  //   text: 'Upload Materials',
  //   id: 'upload-materials-button',
  //   onClick: () => {
  //     const fileUploadInput = document.querySelector(
  //       '#materials-file-upload input',
  //     )
  //     fileUploadInput.click()
  //   },
  // },
  // {
  //   icon: <CloudUpload />,
  //   text: 'Update Materials',
  //   id: 'update-materials-button',
  //   onClick: () => {},
  // },
  // {
  //   icon: <CloudUpload />,
  //   text: 'Upload Prices',
  //   id: 'upload-prices-button',
  //   onClick: () => {},
  // },
  // {
  //   icon: <CloudDownload />,
  //   text: 'Download Prices',
  //   id: 'download-prices-button',
  //   onClick: () => {},
  // },
]

export const ORGANIZATIONS_ACTIONS = [
  {
    icon: <Add />,
    text: 'New Organization',
    id: 'add-organization-button',
    onClick: () => {
      store.dispatch(showFormModal({ formModalName: FORM_MODALS.CREATE_ORGANIZATION }))
    },
  },
]

export const PURCHASES_ACTIONS: AppAction[] = [
  {
    icon: <Add />,
    text: 'Create New Inbound Ticket',
    id: 'create-inbound-ticket-button',
    onClick: navigate => {
      navigate('/app/purchases/ticket-library/new')
    },
    actionPath: 'purchases/ticket-library/new',
  },
  {
    icon: <Add />,
    text: 'Create New Bill',
    id: 'create-bill-button',
    onClick: navigate => {
      navigate('/app/purchases/bills/new')
    },
    actionPath: 'purchases/bills/new',
  },
  {
    icon: <Add />,
    text: 'Create New Batch Bill',
    id: 'create-batch-bill-button',
    onClick: navigate => {
      navigate('/app/purchases/batch-bills/new')
    },
    actionPath: 'purchases/batch-bills/new',
  },
]

export const SALES_ACTIONS: AppAction[] = [
  {
    text: 'Record Payment',
    id: 'record-payment-button',
    onClick: navigate => {
      navigate('/app/sales/invoice-payments/new')
    },
    icon: <Receipt />,
    variant: 'outlined',
    actionPath: 'sales/invoice-payments/new',
  },
  {
    icon: <Add />,
    text: 'Create New Outbound Ticket',
    id: 'create-outbound-ticket-button',
    onClick: navigate => {
      navigate('/app/sales/outbound-tickets/new')
    },
    actionPath: 'sales/outbound-tickets/new',
  },
  {
    text: 'Create New Invoice',
    id: 'new-invoice-button',
    onClick: navigate => {
      navigate('/app/sales/invoices/new')
    },
    icon: <AddCircleOutline />,
    actionPath: 'sales/invoices/new',
  },
]

export const CONTRACT_ACTIONS: AppAction[] = [
  {
    icon: <Add />,
    text: 'New Sales Order',
    id: 'create-sales-order-button',
    onClick: navigate => {
      navigate('/app/contracts/sales-orders/new')
    },
    actionPath: 'contracts/sales-orders/new',
  },
  {
    icon: <Add />,
    text: 'New Purchase Order',
    id: 'create-purchase-order-button',
    onClick: navigate => {
      navigate('/app/contracts/purchase-orders/new')
    },
    actionPath: 'contracts/purchase-orders/new',
  },
]

export const CUSTOMER_ACTIONS = [
  {
    icon: <Add />,
    text: 'New Customer',
    id: 'add-customer-button',
    onClick: () => {
      store.dispatch(showFormModal({ formModalName: FORM_MODALS.NEW_CUSTOMER }))
    },
  },
]

export const ANALYTICS_ACTIONS = []

export const COMMODITIES_ACTIONS: AppAction[] = [
  {
    icon: <RemoveRedEye />,
    text: 'Benchmark Pricing',
    id: 'benchmark-pricing',
    variant: 'outlined',
    onClick: () => {
      store.dispatch(showFormModal({ formModalName: FORM_MODALS.BENCHMARK_PRICING }))
    },
    actionPath: 'inventory/commodities/commodity-list',
  },
  {
    icon: <Add />,
    text: 'Add Commodity',
    id: 'add-commodity',
    variant: 'outlined',
    onClick: () => {
      store.dispatch(showFormModal({ formModalName: FORM_MODALS.NEW_COMMODITY }))
    },
    actionPath: 'inventory/commodities/commodity-list',
  },
  {
    icon: <Add />,
    text: 'Add Material',
    id: 'add-material-type',
    onClick: () => {
      store.dispatch(showFormModal({ formModalName: FORM_MODALS.NEW_MATERIAL }))
    },
    actionPath: 'inventory/commodities/commodity-list',
  },
]

export const FREIGHT_ACTIONS: AppAction[] = [
  {
    icon: <Add />,
    text: 'New Freight Lane',
    id: 'add-freight-lane-button',
    onClick: () => {
      store.dispatch(showFormModal({ formModalName: FORM_MODALS.FREIGHT_LANE_BLADE }))
    },
    actionPath: 'freight/freight-lanes',
  },
  {
    icon: <Add />,
    text: 'New Freight Bill',
    id: 'add-freight-bill-button',
    onClick: navigate => {
      navigate('/app/freight/freight-bills/new')
    },
    actionPath: 'freight/freight-bills/new',
  },
]

export const LOAD_BOARD_ACTIONS = [
  {
    text: 'Manage Drivers',
    id: 'manage-drivers-button',
    variant: 'outlined',
    onClick: () => {
      store.dispatch(showFormModal({ formModalName: FORM_MODALS.MANAGE_DRIVERS_BLADE }))
    },
  },
  {
    icon: <Add />,
    text: 'New Dispatch Ticket',
    id: 'new-dispatch-ticket-button',
    onClick: navigate => {
      navigate('/app/load-board/ticket-history/new')
    },
  },
]

export const ASSETS_ACTIONS = [
  {
    icon: <Add />,
    text: 'Add Truck',
    id: 'add-truck-button',
    onClick: () => {
      store.dispatch(showFormModal({ formModalName: FORM_MODALS.TRUCK_ASSET_BLADE }))
    },
  },
  {
    icon: <Add />,
    text: 'Add Trailer',
    id: 'add-trailer-button',
    onClick: () => {
      store.dispatch(showFormModal({ formModalName: FORM_MODALS.TRAILER_ASSET_BLADE }))
    },
  },
  {
    icon: <Add />,
    text: 'Add Container',
    id: 'add-container-button',
    onClick: () => {
      store.dispatch(showFormModal({ formModalName: FORM_MODALS.CONTAINER_ASSET_BLADE }))
    },
  },
]

export const ORG_MODE_LIST_OBJECT = {
  id: 'ORG_LEVEL_SELECTOR',
  name: ' Org', // This name is set with the intention of concatting it with the Org's name in AppBar.jsx
}

export const USER_PROVISION_ACTIONS = [
  {
    icon: <Add />,
    text: 'NEW USER',
    id: 'add-user-button',
    onClick: () => {
      store.dispatch(showFormModal({ formModalName: 'add-edit-user-blade' }))
    },
  },
]
